import { v4 as uuidv4 } from "uuid";
import { BaseApiService } from "../base/base-api.service";

import { TnAClockingDTO, TnAClockingFilter, TnAClockingSTO, TnAClockingTypeRef } from "../../models/tna";
import { EmployeeDTO, EmployeeRef } from "../../models/employees";
import { TnADateTime } from "../../models/tna/tna-data/tna-date-time";

import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { TnALocationCodeRef } from "../../models/tna-location-codes/tna-location-code-ref";
import { TnAClockingLocationQRCodeRef } from "src/models/tna-clocking-location-qr-code";

export class TnAClockingApiService extends BaseApiService<TnAClockingDTO, TnAClockingSTO> {
  constructor() {
    super({
      servicePath: "/TnAClockings",
      loadItemsPath: "/GetTnAClockings",
      saveItemsPath: "/SaveTnAClockings",
    });
  }
}

export const loadTnaClockings = async (propsFilter: TnAClockingFilter, signal: AbortSignal | undefined) => {
  const response = await new TnAClockingApiService().loadItems(
    propsFilter,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    signal
  );

  toastifyResponse(response, "failed", "default_success_message", "failure_saving_data", "error_saving_data");

  return response;
};

export const saveTnAClockings = async (
  employee: EmployeeRef | null,
  clockingTypeId: string,
  tnADetail: TnADateTime,
  tnALocationCode?: TnALocationCodeRef | null,
  tnALocationCodeOrName?: string,
  forPrevDay?: boolean,
  qrCodeData?: string
) => {
  const clockingDateTime = TnADateTime.ToDateTime(tnADetail);
  const isRealTime = Math.abs(clockingDateTime.getTime() - new Date().getTime()) / 1000 < 60;
  const response = await new TnAClockingApiService().saveItems([
    {
      isDeleted: false,
      id: uuidv4(),
      employee,
      clockingType: { id: clockingTypeId } as TnAClockingTypeRef,
      legalEntity: employee?.legalEntity ?? null,
      companyAccount: employee?.companyAccount ?? null,
      tnADetail,
      forPrevDay: !!forPrevDay,
      isRealTimeClocking: isRealTime,
      tnALocationCode: tnALocationCode ?? null,
      tnALocationCodeOrName: tnALocationCodeOrName ?? "",
      tnAClockingLocationQRCode: null,
      qrCodeData: qrCodeData ?? "",
    },
  ]);

  toastifyResponse(response);

  return response;
};
